/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/

import React from 'react';
import { Modal } from 'react-bootstrap';

const FileSamplesView = (props) => {
    const { isShowModal, closeModal, imgModalArray, imgModalTitle } = props;
    return(
        <Modal show={isShowModal} onHide={closeModal}>
            <Modal.Header closeButton>
                <Modal.Title>{imgModalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    imgModalArray.map((item, index) => {
                        return (
                            <div key={index}>
                                <h4>{item.title}</h4>
                                <p><img src={item.imgSrc} className="f-img" alt={item.title} /></p>
                            </div>
                        );
                    })
                }
            </Modal.Body>
        </Modal>
    );
};

export default FileSamplesView;


// WEBPACK FOOTER //
// ./src/views/FileUploadInfo/components/child/FileSamplesView.js